import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { MiInputTextbox, MiModal } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, TextField } from "@mui/material";

export const CreateBackchargeModal = ({
  open,
  isLoading,
  selectedBackcharge,
  onClose,
  onSubmit,
}) => {
  const [poNumber, setPoNumber] = useState("");
  const [amount, setAmount] = useState(0);
  const [notes, setNotes] = useState("");

  const isEditMode = !!selectedBackcharge;
  const isValid = poNumber.trim().length > 0 && amount > 0;

  useEffect(() => {
    if (open && selectedBackcharge) {
      setPoNumber(selectedBackcharge.poNumber || "");
      setAmount(selectedBackcharge.amount || 0);
      setNotes(selectedBackcharge.notes || "");
    } else if (!open) {
      setPoNumber("");
      setAmount(0);
      setNotes("");
    }
  }, [open, selectedBackcharge]);

  const handleClose = () => {
    setPoNumber("");
    setAmount(0);
    setNotes("");
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({ poNumber, amount: Number(amount), notes });
  };

  return (
    <MiModal
      open={open}
      closeModal={handleClose}
      title={isEditMode ? "Edit Backcharge" : "Create Backcharge"}
      titleIcon={mdi.mdiCurrencyUsd}
      width={500}
      loading={isLoading}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: handleClose,
        },
        {
          name: isEditMode ? "Update Backcharge" : "Create Backcharge",
          disabled: !isValid || isLoading,
          variant: BUTTON_VARIANTS.CONTAINED,
          onClick: handleSubmit,
        },
      ]}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 1 }}>
        <TextField
          data-testid="backcharge-po-number"
          label="PO Number"
          value={poNumber}
          onChange={(e) => setPoNumber(e.target.value)}
          required
          fullWidth
          size="small"
        />
        <NumericFormat
          testID="backcharge-po-amount"
          customInput={MiInputTextbox}
          thousandSeparator
          required
          label="Amount"
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          allowLeadingZeros={false}
          prefix="$"
          value={amount || ""}
          onValueChange={(values) => setAmount(values.floatValue ?? 0)}
        />
        <TextField
          data-testid="backcharge-po-notes"
          label="Notes"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          multiline
          rows={3}
          fullWidth
          size="small"
        />
      </Box>
    </MiModal>
  );
};
